import { render, staticRenderFns } from "./card-options.vue?vue&type=template&id=4f873f48&scoped=true&lang=pug&"
import script from "./card-options.vue?vue&type=script&lang=coffee&"
export * from "./card-options.vue?vue&type=script&lang=coffee&"
import style0 from "./card-options.vue?vue&type=style&index=0&id=4f873f48&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f873f48",
  null
  
)

export default component.exports